import React, { useState} from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import { logout } from '../actions/User';
import { resetPasswordByOld } from '../actions/Users';
import * as UsersActions from '../actions/Users';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faSync } from '@fortawesome/free-solid-svg-icons';

const UpdateUserPasswordModal = ({
  isOpen,
  onConfirm,
  onCancel,
  resetPasswordByOld,
  user,
  logout,
  resetPassword,
  userLoginPasswordResetOnLogin,
  intervalId
}) => {
  const token = localStorage.getItem('jwtToken');

  const [oldPass, setOldPass] = useState('');
  const [newPass, setNewPass] = useState('');
  const [repeatNewPass, setRepeatNewPass] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showNewPass, setShowNewPass] = useState(false);
  const [isAutoGenerate, setIsAutoGenerate] = useState(false);

  const onPassSee = () => {
    setShowNewPass(!showNewPass)
  }

  const onPassCopy = () => {
    if(newPass){
      navigator.clipboard.writeText(newPass);
      return;
    }
    navigator.clipboard.writeText(' ');
  }

  const onSubmit = async e => {
    e.preventDefault();
    const id = user._id;
    if (newPass === repeatNewPass || isAutoGenerate) {
      const re = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      const passwordCheck = re.test(newPass);
      try {
        console.log(isAutoGenerate)
        if (passwordCheck || isAutoGenerate) {
          await resetPasswordByOld(token, id, oldPass, newPass || null, isAutoGenerate);
          await userLoginPasswordResetOnLogin(token, false);

          setTimeout(() => {
            logout(token, intervalId);
          }, 1000);
        } else {
          setErrorMessage(
            'Password should be minimum of 8 characters, one Upper case, one lower case, 1 number, 1 symbol',
          );
        }
      } catch (error) {}
    } else {
      setErrorMessage('Passwords do not match. Please try again.');
    }
  };

  return (
    <Modal isOpen={isOpen || user.resetPassword} size={'lg'}>
      <ModalHeader>Reset Password</ModalHeader>
      <ModalBody>
        <Form id="resetPassUser" onSubmit={onSubmit}>
          <FormGroup>
            <Label>Old Password</Label>
            <Input
              type={showNewPass ? "text" : "password"}
              value={oldPass}
              onChange={({ currentTarget }) => setOldPass(currentTarget.value.trim())}
              onFocus={() => setErrorMessage('')}
              autoComplete="current-password"
              required
              placeholder="Enter your old password"
              // minLength="6"
            />
          </FormGroup>
          {!isAutoGenerate && (
            <>
          <FormGroup>
            <Label>New Password</Label>
            <InputGroup>
                <Input
                  className="input-field"
                  type={showNewPass ? "text" : "password"}
                  value={newPass}
                  onChange={({ currentTarget }) => setNewPass(currentTarget.value.trim())}
                  onFocus={() => setErrorMessage('')}
                  autoComplete="new-password"
                  required
                  // minLength="6"
                  placeholder="Enter your new password"
                  style={{ borderRight: '0px !important' }}
                />
              <InputGroupAddon addonType="append" className="show-password" style={{zIndex: '100'}}>
                <FontAwesomeIcon onClick={onPassSee} title="Show Password" icon={!showNewPass ? 'eye-slash' : 'eye'} size="lg" color="#8998ac" style={{marginRight: '10px'}} />
                <FontAwesomeIcon onClick={onPassCopy} title="Copy Password" icon={faCopy} size="lg" color="#8998ac" style={{marginRight: '10px'}} />
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>Repeat New Password</Label>
            <Input
              type={showNewPass ? "text" : "password"}
              value={repeatNewPass}
              onChange={({ currentTarget }) => setRepeatNewPass(currentTarget.value.trim())}
              onFocus={() => setErrorMessage('')}
              autoComplete="new-password"
              required
              // minLength="6"
              placeholder="Repeat your new password"
            />
          </FormGroup></>)}
          {/* <FormGroup check>
            <Input type="checkbox" onClick={() => setIsAutoGenerate(!isAutoGenerate)}/>
            <Label check>Generate password automatically</Label>
          </FormGroup> */}
        </Form>
        {errorMessage && <span style={{ color: '#3b5aa9' }}>{errorMessage}</span>}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onConfirm} type="submit" form="resetPassUser">
          Reset
        </Button>{' '}
        <Button hidden={user.resetPassword} color="secondary" onClick={onCancel} type="button">
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = state => ({
  user: state.AppState.user,
  intervalId: state.UIState.users.intervalId
});

const mapDispatchToProps = dispatch => ({
  resetPasswordByOld: (token, id, oldPass, newPass, isAutoGenerate) =>
    dispatch(resetPasswordByOld(token, id, oldPass, newPass, isAutoGenerate)),
  logout: (token, interval) => dispatch(logout(token, interval)),
  userLoginPasswordResetOnLogin: (token, resetValue) => dispatch(UsersActions.userLoginPasswordResetOnLogin(token, resetValue)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateUserPasswordModal);
